import Crud from '../views/Lgpd/Crud'
import Entity from '../views/Lgpd/Add'
import Public from '../views/Lgpd/Public'

let routes = {
    path: '/lgpds',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/lgpds/add',
            name: 'NewLgpd',
            component: Entity,
            meta: {
                pageTitle: 'Solicitações LGPD',
                breadcrumb: [
                    {
                        text: 'Solicitações LGPD',
                        active: false,
                        to: '/lgpds',
                    },
                    {
                        text: 'Adicionar Solicitação',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/lgpds/edit/:id?',
            name: 'EditLgpd',
            component: Entity,
            meta: {
                pageTitle: 'Solicitações LGPD',
                breadcrumb: [
                    {
                        text: 'Solicitações LGPD',
                        active: false,
                        to: '/lgpds',
                    },
                    {
                        text: 'Editar Solicitação',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/lgpds',
            name: 'list-lgpd',
            component: Crud,
            meta: {
                pageTitle: 'Solicitações LGPD',
                breadcrumb: [
                    {
                        text: 'Solicitações LGPD',
                        active: true,
                    },
                ],
            },
        }
    ]
};

export default routes;
